import React from "react";
import { Spin } from "antd";
import { GoogleApiWrapper } from "google-maps-react";
import  {getGoogleMapsApiKey, getCachedGoogleMapsApiKey} from "./api-key-service";  

const withGoogleMaps = (WrappedComponent) => {
  class GoogleMapsProvider extends React.Component {
    constructor(props) {
      super(props);
      
      const cachedKey = getCachedGoogleMapsApiKey();
      this.state = {
        apiKey: cachedKey,
        loading: !cachedKey,
        error: null,
      };

      // If key is cached, we can initialize the enhanced component immediately
      this.EnhancedComponent = cachedKey 
        ? GoogleApiWrapper({ apiKey: cachedKey })(WrappedComponent)
        : null;
    }

    async componentDidMount() {
      // If key is already available from constructor/cache, don't fetch again
      if (this.state.apiKey) return;

      try {
        const apiKey = await getGoogleMapsApiKey();
        // Create the GoogleApiWrapper-wrapped component once the key is available
        this.EnhancedComponent = GoogleApiWrapper({ apiKey })(WrappedComponent);
        this.setState({ apiKey, loading: false });
      } catch (error) {
        console.error("Failed to load Google Maps API key:", error);
        this.setState({ error, loading: false });
      }
    }

    render() {
      const { forwardedRef, ...rest } = this.props;

      if (this.state.loading) {
        return (
          <div style={{ height: "100%", width: "100%", display: "flex", alignItems: "center", justifyContent: "center", minHeight: "300px" }}>
            <Spin spinning={true} />
          </div>
        );
      }

      if (this.state.error || !this.EnhancedComponent) {
        return <div style={{ padding: "20px", textAlign: "center" }}>Error loading Google Maps. Please try again later.</div>;
      }

      const EnhancedComponent = this.EnhancedComponent;
      return <EnhancedComponent {...rest} ref={forwardedRef} />;
    }
  }

  // Use React.forwardRef to pass refs through the HOC
  const ForwardedGoogleMapsProvider = React.forwardRef((props, ref) => {
    return <GoogleMapsProvider {...props} forwardedRef={ref} />;
  });

  // Preserve the display name for debugging
  const wrappedName = WrappedComponent.displayName || WrappedComponent.name || "Component";
  ForwardedGoogleMapsProvider.displayName = `withGoogleMaps(${wrappedName})`;

  return ForwardedGoogleMapsProvider;
};

export default withGoogleMaps;
